import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import '@lottiefiles/lottie-player';
import Accordion from "./Classes/Accordion.js";
import Video from "./Classes/Video.js";
import HeroSlider from "./Classes/HeroSlider.js";
import DrawHighcharts from "./Classes/DrawHighcharts";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import ImageContainerResizer from "./Classes/imageContainerResizer";
import HeroSeparatorCoverOverlap from "./Classes/HeroSeparatorCoverOverlap";
import AnimationStartpage from "./Classes/AnimationStartpage";
import RegisterTab from './Classes/RegisterTab.js';
import Gri from "./Classes/Gri"
import XDownloader from "./Classes/XDownloader";
import xdownloaderConfig from './xdownloader-config.js';
import customSwiper from "./Classes/customSwiper.js";
import CountUpNumbers from './Classes/CountUpNumbers.js';
import LottieSwiper from "./Classes/LottieSwiper.js";
import PausePlayVideo from "./Classes/videoPausePlay.js";
import Scrollspy from "./Classes/Scrollspy";

var heroSliderInstance = null;
let imageContainerResizerInstance = null;
let heroSeparatorCoverOverlapInstance = null;

window.addEventListener("page_event_load", () => {
  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new AnimationStartpage();

  new customSwiper();

   const countUpInstance = new CountUpNumbers({
     numbersSelector: '.countup--item',
     classIn: 'is-in-viewport',
     classOut: 'is-not-in-viewport',
     langArray: ['de', 'en'],
     decimalArray: ['.', '.'],
     thousandSepArray: ['’', '’'],
   });

  new Video();
  new Scrollspy();

  new Swiper(".lc-keyfigure-slider .lc-keyfigure-slider__container", {
    modules: [Navigation],
    paginationClickable: true,
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 50,
        slidesPerView: 2
      }
    },
  });

  new DrawHighcharts();

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table:not(.lc-option--is-taxonomy-table)',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new RegisterTab();

  heroSliderInstance = new HeroSlider();

  new Gri();

  new XDownloader(xdownloaderConfig);

  new PausePlayVideo();


});

window.addEventListener("page_event_load", () => {
  new PausePlayVideo();
});

window.addEventListener('page_event_unloading', () => {
  heroSliderInstance?.unbindEvents();
  heroSliderInstance = null;
});

window.addEventListener("page_event_load", () => {
    imageContainerResizerInstance = new ImageContainerResizer();
  heroSeparatorCoverOverlapInstance = new HeroSeparatorCoverOverlap();
    new LottieSwiper();
});

window.addEventListener("page_event_unloading", () => {
    if (imageContainerResizerInstance) {
        imageContainerResizerInstance.unsubscribe();
        imageContainerResizerInstance = null;
    }

  if (heroSeparatorCoverOverlapInstance) {
    heroSeparatorCoverOverlapInstance.unsubscribe();
    heroSeparatorCoverOverlapInstance = null;
  }
});

window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});

window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});

export default {
  data() {
    return {
      sections: [],
      activeSection: null
    };
  },
  mounted() {
    // Initialize Scrollspy and update sections after the component is mounted
    this.scrollspy = new Scrollspy();
    this.scrollspy.init();  // Initialize and populate sections
    this.sections = this.scrollspy.sections;  // Bind sections to Vue data
  }
};
